<template>
	<div class="grid">
		<div class="col-12 lg:col-12 xl:col-12">
			<div class="card mb-0">
				
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="type">URL Laporan</label>
					<div class="p-inputgroup flex-1">
						<InputText id="laporan" aria-describedby="laporan-help" :value="domain + '/laporan'" readonly/>
						<Button icon="pi pi-clone" @click="copyData('Url Laporan', domain + '/laporan')"/>
					</div>
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="type">URL Detail Laporan</label>
					<div class="p-inputgroup flex-1">
						<InputText id="detail-laporan" aria-describedby="detail-laporan-help" :value="domain + '/'" readonly/>
						<Button icon="pi pi-clone" @click="copyData('Url Detail Laporan', domain + '/')"/>
					</div>
        </div>
			</div>
		</div>
		<div class="col-12 lg:col-4 xl:col-4">
			<div class="card mb-0" @click="toggle($event, 'belum')">
				<div class="flex justify-content-between">
					<div class="align-center">
						<h4 class="m-0">Belum Diproses</h4>
					</div>
					<div class="">
						<h4 class="m-0 text-red-500">{{merge.belum}}</h4>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 lg:col-4 xl:col-4">
			<div class="card mb-0" @click="toggle($event, 'sedang')">
				<div class="flex justify-content-between">
					<div class="align-center">
						<h4 class="m-0">Sedang Diproses</h4>
					</div>
					<div class="">
						<h4 class="m-0 text-green-500">{{merge.sedang}}</h4>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 lg:col-4 xl:col-4">
			<div class="card mb-0">
				<div class="flex justify-content-between">
					<div class="align-center">
						<h4 class="m-0">Rata Rata</h4>
					</div>
					<div class="">
						<h4 class="m-0 text-yellow-500">{{merge.rata_rata}}</h4>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 lg:col-4 xl:col-4">
			<div class="card mb-0">
				<div class="flex justify-content-between">
					<div class="align-center">
						<h4 class="m-0">Operator</h4>
					</div>
					<div class="">
						<h4 class="m-0 text-primary">{{merge.rata_rata_operator}}</h4>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 lg:col-4 xl:col-4">
			<div class="card mb-0">
				<div class="flex justify-content-between">
					<div class="align-center">
						<h4 class="m-0">Supervisor</h4>
					</div>
					<div class="">
						<h4 class="m-0 text-primary">{{merge.rata_rata_supervisor}}</h4>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 lg:col-4 xl:col-4">
			<div class="card mb-0">
				<div class="flex justify-content-between">
					<div class="align-center">
						<h4 class="m-0">Manager</h4>
					</div>
					<div class="">
						<h4 class="m-0 text-primary">{{merge.rata_rata_manager}}</h4>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 lg:col-12 xl:col-12 md:col-12" >
			<div class="card mb-0">
				<div class="grid mb-0">
					<div class="col-12 lg:col-6 flex flex-column gap-2">
						<label for="asal_pemohon">Bulan</label>
						<Dropdown 
							v-model="data.bulan" 
							optionLabel="text" 
							optionValue="value" 
							:options="listBulan" 
							placeholder="pilih bulan" 
							class="w-full" 
						/>
					</div>
					<div class="col-12 lg:col-6 flex flex-column gap-2">
						<label for="asal_pemohon">Tahun</label>
						<Calendar locale="id" id="asal_pemohon" class="w-full" v-model="data.tahun" showButtonBar view="year" dateFormat="yy"/>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="col-12 lg:col-6 xl:col-6"></div> -->
		<div class="col-12 lg:col-6 xl:col-6 md:col-6" >
			<div class="card mb-0">
				<h3 class="">Pengaduan</h3>
				<hr>
				<div class="mt-5 mx-0 xl:mx-8 md:mx-4 sm:mx-0">
					<h4 class="text-center">Asal</h4>
					<Chart type="doughnut" :data="pengaduan_asal" class="w-full" />
				</div>
				<div class="mt-7 mx-0 xl:mx-8 md:mx-4 sm:mx-0">
					<h4 class="text-center">Kategori</h4>
					<Chart type="doughnut" :data="pengaduan_kategori" class="w-full" />
				</div>
				<div class="mt-7 mx-0 xl:mx-8 md:mx-4 sm:mx-0">
					<h4 class="text-center">Harian</h4>
					<Chart type="bar" :data="pengaduan_harian" class="w-full" />
				</div>
			</div>
		</div>
		<div class="col-12 lg:col-6 xl:col-6 md:col-6" >
			<div class="card mb-0">
				<h3 class="">Permohonan</h3>
				<hr>
				<div class="mt-5 mx-0 xl:mx-8 md:mx-4 sm:mx-0">
					<h4 class="text-center">Asal</h4>
					<Chart type="doughnut" :data="permohonan_asal" class="w-full" />
				</div>
				<div class="mt-7 mx-0 xl:mx-8 md:mx-4 sm:mx-0">
					<h4 class="text-center">Kategori</h4>
					<Chart type="doughnut" :data="permohonan_kategori" class="w-full" />
				</div>
				<div class="mt-7 mx-0 xl:mx-8 md:mx-4 sm:mx-0">
					<h4 class="text-center">Harian</h4>
					<Chart type="bar" :data="permohonan_harian" class="w-full" />
				</div>
			</div>
		</div>
		<OverlayPanel ref="op" v-model:visible="visibleProses">
			<Button :label="'Permohonan ' + permohonan[proses]" raised @click="toProses('permohonan')"/>
			<Button :label="'Pengaduan ' + pengaduan[proses]" class="ml-2" raised @click="toProses('pengaduan')"/>
		</OverlayPanel>
	</div>
</template>

<script>
import EventBus from '@/AppEventBus';
import ProductService from '../../service/ProductService';

export default {
	data() {
		return {
			domain: window.location.origin,
			visibleProses: false,
			proses: null,
			data: {
				bulan: this.$moment().format('MM'),
				tahun: new Date(),
			},
			listBulan: [
				{value: '01', text: 'Januari'},
				{value: '02', text: 'Februari'},
				{value: '03', text: 'Maret'},
				{value: '04', text: 'April'},
				{value: '05', text: 'Mei'},
				{value: '06', text: 'Juni'},
				{value: '07', text: 'Juli'},
				{value: '08', text: 'Agustus'},
				{value: '09', text: 'September'},
				{value: '10', text: 'Oktober'},
				{value: '11', text: 'November'},
				{value: '12', text: 'Desember'},
			],
			pengaduan: {
				belum: 0,
				sedang: 0,
				rataMilis: 0,
				rata_rata: '',
				rata: {},
			},
			permohonan: {
				belum: 0,
				sedang: 0,
				rataMilis: 0,
				rata_rata: '',
				rata: {},
			},
			merge: {
				belum: 0,
				sedang: 0,
				rataMilis: 0,
				rata_rata: '',
			},
			pengaduan_asal: [],
			pengaduan_kategori: [],
			pengaduan_harian: [],
			permohonan_asal: [],
			permohonan_kategori: [],
			permohonan_harian: [],
		}
	},
	productService: null,
	themeChangeListener: null,
	async mounted() {
		this.getCount()
		this.getData()
		this.productService.getProductsSmall().then(data => this.products = data);

		this.themeChangeListener = (event) => {
			if (event.dark)
				this.applyDarkTheme();
			else
				this.applyLightTheme();
		};
		EventBus.on('change-theme', this.themeChangeListener);
		if (this.isDarkTheme()) {
			this.applyDarkTheme();
		} else {
			this.applyLightTheme();
		}
	},
	beforeUnmount() {
		EventBus.off('change-theme', this.themeChangeListener );
	},
	created() {
		this.productService = new ProductService();
	},
	watch: {
		'data.bulan'(newVal, oldVal){
			if(newVal != oldVal){
				this.getData()
			}
		},
		'data.tahun'(newVal, oldVal){
			if(newVal != oldVal){
				this.getData()
			}
		}
	},
	methods: {
		toggle(event, proses) {
			const vm = this
			vm.$refs.op.toggle(event);
			vm.proses = proses
		},
		toProses(name){
			const vm = this
			vm.$router.push(`/${name}?type=${vm.proses}`)
		},
    async copyData(nama, url){
      const vm = this
      // console.log(window.location.origin)
      await navigator.clipboard.writeText(url);
			vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Berhasil Copy ' + nama, life: 3000 });
    },
		async toChart(nama, datas, label){
			label
			// const vm = this
			let labels = []
			let data = []
			for (let i = 0; i < datas.length; i++) {
				const x = datas[i];
				labels.push(x.label)
				data.push(x.data)
			}
			return {
				labels: labels,
				datasets: [
					{
						label: label,
						data: data,
						backgroundColor: [
							"#0079FF",
							"#00DFA2",
							"#F6FA70",
							"#FF0060",
							"#F2BE22",
							"#22A699",
							"#F29727",
							"#F24C3D",
						],
					}
				]
			}
		},
		async getData(){
			const vm = this
			vm.getPengaduanAsal()
			vm.getPengaduanKategori()
			vm.getPengaduanHarian()
			vm.getPermohonanAsal()
			vm.getPermohonanKategori()
			vm.getPermohonanHarian()
		},
		async getPengaduanAsal(){
			const vm = this
			const pengaduan_asal = await vm.$axios.post('/pengaduan/sum_pengaduan_by_asal', {
				bulan: vm.data.bulan,
				tahun: vm.$moment(vm.data.tahun).format('YYYY'),
			})
			vm.pengaduan_asal = await vm.toChart(
				'pengaduan_asal', 
				pengaduan_asal.data.data.map(x => {
					return {
						...x,
						label: x.asal,
						data: x.count,
					}
				})
			)
		},
		async getPengaduanKategori(){
			const vm = this
			const pengaduan_kategori = await vm.$axios.post('/pengaduan/sum_pengaduan_by_kategori', {
				bulan: vm.data.bulan,
				tahun: vm.$moment(vm.data.tahun).format('YYYY'),
			})
			vm.pengaduan_kategori = await vm.toChart(
				'pengaduan_kategori', 
				pengaduan_kategori.data.data.map(x => {
					return {
						...x,
						label: x.nama_kategori,
						data: x.count,
					}
				})
			)
		},
		async getPengaduanHarian(){
			const vm = this
			const pengaduan_harian = await vm.$axios.post('/pengaduan/sum_pengaduan_harian', {
				bulan: vm.data.bulan,
				tahun: vm.$moment(vm.data.tahun).format('YYYY'),
			})
			vm.pengaduan_harian = await vm.toChart(
				'pengaduan_harian', 
				pengaduan_harian.data.data.map(x => {
					return {
						...x,
						label: vm.$moment(x.date).format('LL'),
						data: x.count,
					}
				}),
				'Harian'
			)
		},
		async getPermohonanAsal(){
			const vm = this
			const permohonan_asal = await vm.$axios.post('/permohonan/sum_permohonan_by_asal', {
				bulan: vm.data.bulan,
				tahun: vm.$moment(vm.data.tahun).format('YYYY'),
			})
			vm.permohonan_asal = await vm.toChart(
				'permohonan_asal', 
				permohonan_asal.data.data.map(x => {
					return {
						...x,
						label: x.asal,
						data: x.count,
					}
				})
			)
		},
		async getPermohonanKategori(){
			const vm = this
			const permohonan_kategori = await vm.$axios.post('/permohonan/sum_permohonan_by_kategori', {
				bulan: vm.data.bulan,
				tahun: vm.$moment(vm.data.tahun).format('YYYY'),
			})
			vm.permohonan_kategori = await vm.toChart(
				'permohonan_kategori', 
				permohonan_kategori.data.data.map(x => {
					return {
						...x,
						label: x.nama_kategori,
						data: x.count,
					}
				})
			)
		},
		async getPermohonanHarian(){
			const vm = this
			const permohonan_harian = await vm.$axios.post('/permohonan/sum_permohonan_harian', {
				bulan: vm.data.bulan,
				tahun: vm.$moment(vm.data.tahun).format('YYYY'),
			})
			// permohonan_harian.data.data = permohonan_harian.data.data.concat(permohonan_harian.data.data, permohonan_harian.data.data, permohonan_harian.data.data, permohonan_harian.data.data, permohonan_harian.data.data, permohonan_harian.data.data, permohonan_harian.data.data, permohonan_harian.data.data)
			vm.permohonan_harian = await vm.toChart(
				'permohonan_harian', 
				permohonan_harian.data.data.map(x => {
					return {
						...x,
						label: vm.$moment(x.date).format('LL'),
						data: x.count,
					}
				}),
				'Harian'
			)
		},
		async getCount(){
			const vm = this
			// pengaduan
			vm.pengaduan.belum = Number.parseInt((await vm.$axios.post('pengaduan/belum_diproses')).data.data[0].count)
			vm.pengaduan.sedang = Number.parseInt((await vm.$axios.post('pengaduan/sedang_diproses')).data.data[0].count)
			vm.pengaduan.rata = (await vm.$axios.post('pengaduan/avg_manajer')).data
			if (vm.pengaduan.rata.days > 0) vm.pengaduan.rata_rata += vm.pengaduan.rata.days + ' hari '
			if (vm.pengaduan.rata.hours > 0) vm.pengaduan.rata_rata += vm.pengaduan.rata.hours + ' jam '
			if (vm.pengaduan.rata.mins > 0) vm.pengaduan.rata_rata += vm.pengaduan.rata.mins + ' menit '
			// console.log('pengaduan', vm.pengaduan)

			// permohonan
			vm.permohonan.belum = Number.parseInt((await vm.$axios.post('permohonan/belum_diproses')).data.data[0].count)
			vm.permohonan.sedang = Number.parseInt((await vm.$axios.post('permohonan/sedang_diproses')).data.data[0].count)
			vm.permohonan.rata = (await vm.$axios.post('permohonan/avg_manajer')).data
			if (vm.permohonan.rata.days > 0) vm.permohonan.rata_rata += vm.permohonan.rata.days + ' hari '
			if (vm.permohonan.rata.hours > 0) vm.permohonan.rata_rata += vm.permohonan.rata.hours + ' jam '
			if (vm.permohonan.rata.mins > 0) vm.permohonan.rata_rata += vm.permohonan.rata.mins + ' menit '
			// console.log('permohonan', vm.permohonan)

			//merge
			vm.merge.belum = Math.round(vm.permohonan.belum + vm.pengaduan.belum)
			vm.merge.sedang = Math.round(vm.permohonan.sedang + vm.pengaduan.sedang)
			// vm.permohonan.rataMilis = await vm.$moment.duration({days: vm.permohonan.rata.days, hours: vm.permohonan.rata.hours, minutes: vm.permohonan.rata.mins });
			// vm.pengaduan.rataMilis = await vm.$moment.duration({days: vm.pengaduan.rata.days, hours: vm.pengaduan.rata.hours, minutes: vm.pengaduan.rata.mins });
			// vm.merge.rataMilis = ((vm.permohonan.rataMilis.asMilliseconds() + vm.pengaduan.rataMilis.asMilliseconds()) / 2)
			// let x = vm.$moment.duration(vm.merge.rataMilis)
			// vm.merge.rata_rata = `${x._data.days} hari ${x._data.hours} jam ${x._data.minutes} menit`;

			
			vm.merge.rata_operator = (await vm.$axios.post('gabungan/avg_operator')).data
			vm.merge.rata_rata_operator = ``
			if (vm.merge.rata_operator.days > 0) vm.merge.rata_rata_operator += vm.merge.rata_operator.days + ' hari '
			if (vm.merge.rata_operator.hours > 0) vm.merge.rata_rata_operator += vm.merge.rata_operator.hours + ' jam '
			if (vm.merge.rata_operator.mins > 0) vm.merge.rata_rata_operator += vm.merge.rata_operator.mins + ' menit '

			vm.merge.rata_supervisor = (await vm.$axios.post('gabungan/avg_supervisor')).data
			vm.merge.rata_rata_supervisor = ``
			if (vm.merge.rata_supervisor.days > 0) vm.merge.rata_rata_supervisor += vm.merge.rata_supervisor.days + ' hari '
			if (vm.merge.rata_supervisor.hours > 0) vm.merge.rata_rata_supervisor += vm.merge.rata_supervisor.hours + ' jam '
			if (vm.merge.rata_supervisor.mins > 0) vm.merge.rata_rata_supervisor += vm.merge.rata_supervisor.mins + ' menit '

			vm.merge.rata_manager = (await vm.$axios.post('gabungan/avg_manajer')).data
			vm.merge.rata_rata_manager = ``
			if (vm.merge.rata_manager.days > 0) vm.merge.rata_rata_manager += vm.merge.rata_manager.days + ' hari '
			if (vm.merge.rata_manager.hours > 0) vm.merge.rata_rata_manager += vm.merge.rata_manager.hours + ' jam '
			if (vm.merge.rata_manager.mins > 0) vm.merge.rata_rata_manager += vm.merge.rata_manager.mins + ' menit '

			vm.merge.rata= (await vm.$axios.post('gabungan/avg_all')).data
			// console.log('gabungan/avg_all', vm.merge.rata)
			vm.merge.rata_rata= ``
			if (vm.merge.rata.days > 0) vm.merge.rata_rata += vm.merge.rata.days + ' hari '
			if (vm.merge.rata.hours > 0) vm.merge.rata_rata += vm.merge.rata.hours + ' jam '
			if (vm.merge.rata.mins > 0) vm.merge.rata_rata += vm.merge.rata.mins + ' menit '
		},
		formatCurrency(value) {
			return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
		},
		isDarkTheme() {
			return this.$appState.darkTheme === true;
		},
		applyLightTheme() {
			this.lineOptions = {
				plugins: {
					legend: {
						labels: {
							color: '#495057'
						}
					}
				},
				scales: {
					x: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
					y: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
				}
			};
		},
		applyDarkTheme() {
			this.lineOptions = {
				plugins: {
					legend: {
						labels: {
							color: '#ebedef'
						}
					}
				},
				scales: {
					x: {
						ticks: {
							color: '#ebedef'
						},
						grid: {
							color:  'rgba(160, 167, 181, .3)',
						}
					},
					y: {
						ticks: {
							color: '#ebedef'
						},
						grid: {
							color:  'rgba(160, 167, 181, .3)',
						}
					},
				}
			};
		}
	}
}
</script>